import { useCallback } from "react";
import type {
    DashboardSafetyIncidentCounts,
    DashboardSafetyData,
    DashboardFleetStatusData,
} from "../../../api";
import { store } from "../../../store";
import { useFetchAction, type UseFetchActionReturn } from "../utils";

export const useFetchDashboardSafety = ({
    dateStart,
    dateEnd,
}: {
    dateStart: Date;
    dateEnd: Date;
}): UseFetchActionReturn<DashboardSafetyData | undefined> => {
    const fetchDashboardSafetyData: () => Promise<DashboardSafetyData | undefined> =
        useCallback(() => {
            return store.dashboardApi.dashboardReadDashboardSafetyData({
                dateStart,
                dateEnd,
            });
        }, [dateStart, dateEnd]);
    return useFetchAction(fetchDashboardSafetyData);
};

export const useFetchDashboardSafetyIncidentCounts = ({
    dateStart,
    dateEnd,
}: {
    dateStart: Date;
    dateEnd: Date;
}): UseFetchActionReturn<DashboardSafetyIncidentCounts | undefined> => {
    const fetchDashboardSafetyIncidentCounts: () => Promise<
        DashboardSafetyIncidentCounts | undefined
    > = useCallback(() => {
        return store.dashboardApi.dashboardReadDashboardSafetyIncidentCounts({
            dateStart,
            dateEnd,
        });
    }, [dateStart, dateEnd]);
    return useFetchAction(fetchDashboardSafetyIncidentCounts);
};

export const useFetchDashboardFleetStatus = ({
    dateStart,
    dateEnd,
    previousDateStart,
    previousDateEnd,
}: {
    dateStart: Date;
    dateEnd: Date;
    previousDateStart: Date;
    previousDateEnd: Date;
}): UseFetchActionReturn<DashboardFleetStatusData | undefined> => {
    const fetchDashboardFleetStatus: () => Promise<DashboardFleetStatusData | undefined> =
        useCallback(() => {
            return store.dashboardApi.dashboardReadDashboardFleetStatusData({
                dateStart,
                dateEnd,
                datePreviousStart: previousDateStart,
                datePreviousEnd: previousDateEnd,
            });
        }, [dateStart, dateEnd, previousDateStart, previousDateEnd]);
    return useFetchAction(fetchDashboardFleetStatus);
};
